import {
  MaterialCiqIcon,
  ScheduleCiqIcon,
  SubmittalCiqIcon
} from "components/svg-icons";
import { useMemo } from "react";
import BidPackageCiqIcon from "./bid-package-ciq-icon";
import ConstructionCiqIcon from "./construction-ciq-icon";
import DesignPackageCiqIcon from "./design-package-ciq-icon";

function CiqIconCircle({
  feature,
  size = 12,
  padding = 8
}: {
  size?: number;
  padding?: number;
  feature:
    | "MATERIALS"
    | "SUBMITTALS"
    | "DESIGN_PACKAGE"
    | "BID_PACKAGE"
    | "CONSTRUCTION"
    | "SCHEDULES";
}) {
  const getInfo = useMemo(() => {
    switch (feature) {
      case "MATERIALS":
        return {
          icon: (
            <MaterialCiqIcon
              size={size}
              className="fill-ciq-teal-700"
              opacity="1"
            />
          ),
          color: "var(--ciq-teal-200)"
        };
      case "SUBMITTALS":
        return {
          icon: (
            <SubmittalCiqIcon
              size={size}
              className="fill-ciq-primary-900"
              opacity="1"
            />
          ),
          color: "var(--ciq-primary-900-light)"
        };
      case "SCHEDULES":
        return {
          icon: (
            <ScheduleCiqIcon
              size={size}
              className="fill-ciq-orange-800"
              opacity="1"
            />
          ),
          color: "var(--ciq-orange-400)"
        };
      case "BID_PACKAGE":
        return {
          icon: (
            <BidPackageCiqIcon
              size={size}
              className="fill-ciq-teal-200"
              opacity="1"
            />
          ),
          color: "var(--ciq-blue-700)"
        };
      case "DESIGN_PACKAGE":
        return {
          icon: (
            <DesignPackageCiqIcon
              size={size}
              className="stroke-ciq-blue-200"
              opacity="1"
            />
          ),
          color: "var(--ciq-blue-650)"
        };
      // The tile's crane arm runs to the tile edge, so a circle uses the bare
      // glyph on the tile's background colour instead of clipping the tile.
      case "CONSTRUCTION":
        return {
          icon: (
            <ConstructionCiqIcon
              size={size}
              className="fill-ciq-golden-purple-600"
              opacity="1"
            />
          ),
          color: "#2E3199"
        };

      default:
        break;
    }
    return { icon: null, color: "white" };
  }, [feature, size]);

  return (
    <div
      className="flex items-center justify-center rounded-full"
      style={{ padding, backgroundColor: getInfo.color }}
    >
      {getInfo.icon}
    </div>
  );
}
export default CiqIconCircle;
